/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useCallback, useState } from 'react'
import { useEffect } from 'react';
import { distributorService } from '../../service/distributor.service';
import Resource from './Components/resource';
import FilterModal from './FilterModal';
import InfiniteScroll from 'react-infinite-scroll-component';
import ResourceSkeleton from './Components/resourceSkeleton';
import VideoPlayerModal from './Components/videoplayerPopup';
import { useLocation } from 'react-router-dom';


const sortValues=[{
    id:1,
    name:'Newest First',
    label:'Newest First',
    value:'published_date+desc'
},
{
    id:2,
    name:'Oldest First',
    label:'Oldest First',
    value:'published_date+asc'
},
{
    id:3,
    name:'Resource Name : A-Z',
    label:'Resource Name : A-Z',
    value:'title+asc'
},
{
    id:4,
    name:'Resource Name : Z-A',
    label:'Resource Name : Z-A',
    value:'title+desc'
},
{
    id:5,
    name:' Category Name : A-Z',
    label:' Category Name : A-Z',
    value:'resource_category_name+asc'
},
{
    id:6,
    name:' Category Name : Z-A',
    label:' Category Name : Z-A',
    value:'resource_category_name+desc'
}]


const Resources = () => {
    const [filterPopup, setFilterPopup] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [resourceList, setResourceList] =useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [emptyData, setEmptyData] = useState(false);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState();
    const [searchValue, setSearchValue] = useState('');
    const [timer, setTimer] = useState(null)
    const [filterState, setFilterState] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [sortType, setSortType] = useState('published_date+desc');
    const [sortDropDown, setSortDropdown] = useState(false);
    const [videoPlayerPopup, setVideoplayerPopup] = useState(false);
    const [selectedResource, setSelectedResource] = useState({});
    const [selectedSort, setSelectedSort] = useState('published_date+desc');
    const [imageviewer, setimageViewer] = useState(false)

    const handleFetchCategoryList = async () => {
        const res = await distributorService.GetResourceCategoryList()
        setCategoryList(res.data.data.Items)
    }

    const location= useLocation()
    const searchP = new URLSearchParams(location.search)
    
    if (searchP.get('category')){
        if(!filterState.includes(searchP.get('category'))){
            filterState.push(searchP.get('category'))
        }
    }

    const handleFetchResources = useCallback(async () => {
        // if(currentPage === 1){
        //     setLoading(true)
        //     setResourceList([])
        // }
        const response = await distributorService.ResourceList(currentPage, searchValue, sortType, filterState)
        if(response.data.data.success_status === true) {
            if(response.data.data.Items.length > 0) {
                let arrayWithNoDuplicates = Array.from(new Set([...resourceList, ...response.data.data.Items]))
                setResourceList(arrayWithNoDuplicates)
                setCurrentPage(response.data.data.current_page)  
                setTotalPage(response.data.data.number_of_pages)        
                setEmptyData(false) 
                setLoading(false)
                if(currentPage !== response.data.data.number_of_pages) {
                    setHasMore(true)
                } else {
                    setHasMore(false)
                }
            }
            else{
                setEmptyData(true)
                setHasMore(false)
                setLoading(false)
            }
        }       
    }, [currentPage,totalPage,sortType,filterApplied,searchValue]
    )

    const handlePayload = (item) => {
        setCurrentPage(1)
        setSelectedSort(item)
        setResourceList([])
        setSortType(item)
        setSortDropdown(false)
    }

    const fetchMoreData = () => {
        setCurrentPage(currentPage + 1)
    };

    const inputChanged = (e) => {  
        setResourceList([])
        setCurrentPage(1)
        clearTimeout(timer)

        const newTimer = setTimeout(() => {
            setSearchValue(e.target.value)
            setResourceList([])
            handleFetchResources()
        }, 500)

        setTimer(newTimer)
    }

    useEffect(() => {
        handleFetchResources()  
    }, [currentPage,sortType,filterApplied,searchValue])

    useEffect(() => {
        handleFetchCategoryList()     
    }, [])
    
    return (
        <>
            <div className='pb-[30px]'>   
                <div className="lg:px-[54px] md:px-[46px] px-4">
                    <div className="flex sm:flex-row flex-col justify-between sm:items-center items-start sm:mt-[30px] mt-3.5">
                        <p className="sm:text-xs10 text-lg font-semibold text-[#090406]">Resources</p>
                        <div className="flex flex-wrap items-center sm:mt-0 mt-3">
                            <div className="relative cursor-pointer sm:mb-0 mb-1.5">
                                <label htmlFor=""></label>
                                <input 
                                    type="text" 
                                    className="w-[248px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" 
                                    placeholder="Search" 
                                    // value={searchValue}
                                    onChange={(e) => inputChanged(e)}
                                />
                                <img src="/images/search-box.svg" alt="icon" className="absolute top-[5px] right-1" />
                            </div>
                            <div className="ml-2 dropdown relative sm:mb-0 mb-1.5">
                                <button
                                    type="button"
                                    className="dropdown-toggle sm:h-[34px] h-8 text-xs2 font-semibold text-[#555259] w-[72px] border border-[#555259] rounded-lg"
                                    data-bs-toggle="modal" data-bs-target="#filtermodal"
                                    onClick={() => setFilterPopup(true)}
                                >
                                    Filter
                                </button>
                            </div>
                            <div className="ml-2 dropdown relative sm:mb-0 mb-1.5">
                                <button onClick={() => setSortDropdown(!sortDropDown)} type="button" className="dropdown-toggle sm:h-[34px] h-8 text-xs2 font-semibold text-[#555259] w-[72px] border border-[#555259] rounded-lg transition duration-150 ease-in-out" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    Sort By 
                                    {/* <p className="text-sm font-semibold text-[#555259] px-1.5">{payload.sort && handleSortName()[0].label}</p> */}

                                </button>
                                {sortDropDown &&
                                <ul className="dropdown-menu min-w-max right-0 absolute py-3 bg-[#ffffff] border border-[#E9EDF4] rounded-lg w-[221px]" aria-labelledby="dropdownMenuButton1">
                                    {sortValues.map((item, i) => (
                                        <li className="px-[18px] mb-2.5" key={i}>
                                            <a className="dropdown-item block w-full" href="#">
                                                <div className="relative checkboxRadio">
                                                    <input 
                                                        type="radio" 
                                                        onClick={() => {handlePayload(item.value)}}
                                                        id={`radio11${item.id}`}
                                                        name="radio-group2" 
                                                        className="cursor-pointer" 
                                                        checked={selectedSort === item.value}
                                                    />
                                                    <label htmlFor={`radio11${item.id}`} className="flex">
                                                        <span className="text-sm font-semibold text-[#808285] pl-5 relative cursor-pointer">
                                                            {item.name}
                                                        </span>
                                                    </label>
                                                </div>
                                            </a>
                                        </li>      
                                    ))}
                                                                                   
                                </ul>
                                }
                            </div>
                        </div>
                    </div>
                    {filterPopup && <FilterModal 
                        filterPopup={filterPopup} 
                        setFilterPopup={setFilterPopup} 
                        setCategoryList={setCategoryList} 
                        categoryList={categoryList} 
                        setFilterState={setFilterState}
                        filterState={filterState}
                        handleFetchResources={handleFetchResources}
                        setCurrentPage={setCurrentPage}
                        setResourceList={setResourceList}
                        filterApplied={filterApplied}
                        setFilterApplied={setFilterApplied}
                        setEmptyData={setEmptyData}
                    />}
                </div>
                {loading ? 
                    <ResourceSkeleton /> 
                    : 
                    !emptyData &&
                    <InfiniteScroll
                        dataLength={resourceList.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        className='lg:px-[54px] md:px-[46px] px-4'
                    >
                        <Resource 
                            resourceList={resourceList} 
                            setResourceList={setResourceList} 
                            videoPlayerPopup={videoPlayerPopup} 
                            setVideoplayerPopup={setVideoplayerPopup} 
                            selectedResource={selectedResource}
                            setSelectedResource={setSelectedResource}
                            imageviewer={imageviewer}
                            setimageViewer={setimageViewer}
                        />

                    </InfiniteScroll>}    

            </div>
            <VideoPlayerModal 
                videoPlayerPopup={videoPlayerPopup} 
                setVideoplayerPopup={setVideoplayerPopup} 
                selectedResource={selectedResource}
                setSelectedResource={setSelectedResource}
            />   

            {(emptyData && !loading) &&
                <div className="w-full flex flex-col justify-center items-center h-customh1 px-2 text-center">
                    <img src="/images/Group8022.svg" alt="icon"/>
                    <p className="lg:text-xs16 sm:text-xl text-base font-normal text-[#15090E] sm:pt-[26px] pt-[18px]">Looks like there aren't any <span className="text-[#ED1C24]">Resources</span> updated yet!</p>
                </div>
            }
        </>
        
       
    )
}

export default Resources
